(
    function (skyward, $)
    {
        skyward.reporting = skyward.reporting || {};
        skyward.reporting.aggregateCalculationBuilder = skyward.reporting.aggregateCalculationBuilder || {};

        var calculationInfoByColumnID = {};

        skyward.reporting.aggregateCalculationCollection = {
            populate: function (aggregateCalculationData)
            {
                calculationInfoByColumnID = {};
                for (var calculationData of aggregateCalculationData)
                {
                    skyward.reporting.aggregateCalculationCollection.add(calculationData.columnId, calculationData.calculation, calculationData.name, calculationData.sectionID, calculationData.lineID);
                };
            },
            add: function (columnID, expression, name, sectionID, lineID)
            {
                let columnIDsInCalculation = [];
                for (let bindingPartInfo of getBindingPartsInfo(expression))
                {
                    if (!bindingPartInfo.error)
                    {
                        columnIDsInCalculation.push(bindingPartInfo.columnID)
                    }
                }

                calculationInfoByColumnID[columnID] = {
                    name: name?.toString() ?? "null",
                    sectionID: sectionID,
                    lineID: lineID,
                    columnIDsInCalculation: columnIDsInCalculation
                };
            },
            remove: function (columnID)
            {
                delete calculationInfoByColumnID[columnID];
            },
            deleteColumnsUsingGivenColumnID: function (deletedColumnID, removeColumn)
            {
                for (var columnID in calculationInfoByColumnID)
                {
                    var columnIDsInCalculation = calculationInfoByColumnID[columnID].columnIDsInCalculation;

                    for (var innerColumnID of columnIDsInCalculation)
                    {
                        if (innerColumnID == deletedColumnID)
                        {
                            removeColumn(columnID);
                            skyward.reporting.aggregateCalculationCollection.deleteColumnsUsingGivenColumnID(columnID, removeColumn);
                            break;
                        }
                    }
                }
            }
        }

        var nameIdUniqueForSection = function (name, existingColumnID, sectionID, lineID)
        {
            var isUnique = true;
            for (let columnID in calculationInfoByColumnID)
            {
                let calculationInfo = calculationInfoByColumnID[columnID];

                if (calculationInfo.name.toLowerCase() === name.toLowerCase() && calculationInfo.sectionID === sectionID && calculationInfo.lineID === lineID &&
                    (!existingColumnID || columnID != existingColumnID))
                {
                    isUnique = false;
                }
            }

            return isUnique;
        }

        skyward.reporting.aggregateCalculationBuilder.validateAndGetValues = function (popup, existingAggregateCalculationColumnID, sectionID, lineID, availableColumns)
        {
            var errors = {};

            const nameInput = popup.find("#aggregateCalculationName");
            const nameValue = skyward.extensions.decodeHtml(skyward.controls.getValue(nameInput).trim().toString());
            const nameIsNullLiteral = (nameValue.toLowerCase() === "null");

            if (!nameValue)
            {
                errors["aggregateCalculationName"] = ["Name is a required field."]
            }

            if (nameIsNullLiteral)
            {
                errors["aggregateCalculationName"] = ["Name cannot be 'null'."]
            }

            if (!nameIdUniqueForSection(nameValue, existingAggregateCalculationColumnID, sectionID, lineID))
            {
                errors["aggregateCalculationName"] = ["Name must be unique in the current section's line."]
            }

            var expressionInput = expressionInput = popup.find("#aggregateCalculationExpression");
            var expressionValue = skyward.extensions.decodeHtml(skyward.controls.getValue(expressionInput).trim());

            if (!expressionValue)
            {
                errors["aggregateCalculationExpression"] = ["Expression is a required field."]
            }

            var reportFieldInput = popup.find("#aggregateCalculationReportField");

            var expressionWithBindingsAndDisplayExpression = convertExpressionIntoExpressionWithBindings(errors, expressionValue, expressionInput, reportFieldInput);
            var expressionWithBindings = expressionWithBindingsAndDisplayExpression.expression;
            expressionValue = expressionWithBindingsAndDisplayExpression.displayExpression;

            var deferred = $.Deferred();

            tryParseExpression(expressionWithBindings, availableColumns, expressionValue).then(function (data)
            {
                let calculationJson = null;
                let isFutureValue = false;
                let fieldType = skyward.reporting.DATA_TYPES.NUMBER_DECIMAL;
                if (data.success)
                {
                    expressionWithBindings = data.parsedExpression;
                    calculationJson = JSON.parse(data.calculationJson);
                    isFutureValue = data.isFutureValue;
                    fieldType = data.returnType;
                }
                else
                {
                    errors["aggregateCalculationExpression"] = [data.error];
                    highlightInvalidCharactersInExpression(expressionInput, data.startPosition, data.endPosition);
                }

                var hasErrors = !jQuery.isEmptyObject(errors);

                if (hasErrors)
                {
                    skyward.validation.displayValidationMessages({ errors: errors }, popup, $());
                }

                deferred.resolve({
                    isValid: !hasErrors,
                    name: nameValue,
                    expression: expressionWithBindings,
                    displayExpression: expressionValue,
                    isFutureValue: isFutureValue,
                    calculationJson: calculationJson,
                    fieldType: fieldType
                });
            });

            return deferred;
        };

        var highlightInvalidCharactersInExpression = function (expressionInput, start, end)
        {
            expressionInput.prop({ selectionStart: start, selectionEnd: end });
            expressionInput.focus();
        }

        var convertExpressionIntoExpressionWithBindings = function (errors, expression, expressionInput, reportFieldInput)
        {
            let expressionWithColumnIDBindings = expression;

            for (let bindingPartInfo of getBindingPartsInfo(expressionWithColumnIDBindings, reportFieldInput))
            {
                if (bindingPartInfo.error)
                {
                    errors["aggregateCalculationExpression"] = bindingPartInfo.error;

                    if (bindingPartInfo.endPosition)
                    {
                        highlightInvalidCharactersInExpression(expressionInput, bindingPartInfo.startPosition, bindingPartInfo.endPosition + 1);
                    }
                    else
                    {
                        highlightInvalidCharactersInExpression(expressionInput, bindingPartInfo.startPosition, bindingPartInfo.startPosition + 1);
                    }

                    //break out of loop because we found an error and can only highlight one error at a time.
                    break;
                }
                else
                {
                    expressionWithColumnIDBindings = expressionWithColumnIDBindings.replace(bindingPartInfo.displayBinding, bindingPartInfo.columnIDBinding);
                }
            }

            return {
                displayExpression: expression,
                expression: expressionWithColumnIDBindings
            };
        }

        var getBindingPartsInfo = function (expression, reportFieldInput)
        {
            let bindingPartsInfo = [];

            let bindingMaps = null;

            //if the inputs arent passed in this method will just not be able to populate certain values based
            //on if the binding is a display binding or a back end binding
            if (reportFieldInput)
            {
                bindingMaps = getColumnBindingMaps(reportFieldInput);
            }

            let bindingStartIndex = 0;
            let bindingEndIndex = 0;
            let failedToFindEndBracket = false;

            while (bindingStartIndex !== -1)
            {
                let bindingPartInfo = {
                    startPosition: null,
                    endPosition: null,
                    displayBinding: null,
                    columnIDBinding: null,
                    columnID: null,
                    error: null,
                };

                if (failedToFindEndBracket)
                {
                    bindingEndIndex = bindingStartIndex + 1;
                    failedToFindEndBracket = false;
                }

                bindingStartIndex = expression.indexOf("{", bindingEndIndex);
                if (bindingStartIndex !== -1)
                {
                    bindingPartInfo.startPosition = bindingStartIndex;
                    bindingEndIndex = expression.indexOf("}", bindingStartIndex);
                    if (bindingEndIndex !== -1)
                    {
                        bindingPartInfo.endPosition = bindingEndIndex;

                        let bindingWithBrackets = expression.substr(bindingStartIndex, bindingEndIndex - bindingStartIndex + 1);

                        if (bindingMaps)
                        {
                            if (bindingMaps.columnIDBinding[bindingWithBrackets])
                            {
                                bindingPartInfo.columnIDBinding = bindingMaps.columnIDBinding[bindingWithBrackets];
                                bindingPartInfo.displayBinding = bindingWithBrackets
                            }
                            else if (bindingMaps.displayBinding[bindingWithBrackets])
                            {
                                bindingPartInfo.columnIDBinding = bindingWithBrackets;
                                bindingPartInfo.displayBinding = bindingMaps.displayBinding[bindingWithBrackets];
                            }
                        }
                        else
                        {
                            bindingPartInfo.displayBinding = bindingWithBrackets
                            bindingPartInfo.columnIDBinding = bindingWithBrackets;
                        }

                        const bindingWithoutBrackets = bindingPartInfo.columnIDBinding.substr(1, bindingPartInfo.columnIDBinding.length - 2);
                        const columnBindingsParts = bindingWithoutBrackets.split(".");

                        if (columnBindingsParts.length == 2)
                        {
                            bindingPartInfo.columnID = Number.parseInt(columnBindingsParts[1]);
                        }
                        else
                        {
                            bindingPartInfo.error = ["Field is invalid. Try removing and re-adding."]
                            continue;
                        }
                    }
                    else
                    {
                        failedToFindEndBracket = true;
                        bindingPartInfo.error = ["Could not locate closing bracket."]
                        continue;
                    }

                    bindingPartsInfo.push(bindingPartInfo);
                }
            }

            return bindingPartsInfo;
        }

        function getColumnBindingMaps(reportFieldInput)
        {
            const bindings = {
                columnIDBinding: {},
                displayBinding: {}
            };

            reportFieldInput.find("option").each(function ()
            {
                const option = $(this);
                const binding = option.val();
                const displayBinding = option.data("displayBinding");

                //skip over the blank option
                if (displayBinding)
                {
                    bindings.displayBinding[binding] = displayBinding;
                    bindings.columnIDBinding[displayBinding] = binding;
                }
            });

            return bindings;
        }

        var tryParseExpression = function (expressionWithBindings, allSectionInfo, displayExpression)
        {
            var postedData =
            {
                expression: expressionWithBindings,
                allSectionInfo: skyward.extensions.encodeHtml(JSON.stringify(allSectionInfo)),
                displayExpression: displayExpression
            };
            var url = skyward.global.virtualDir + "Reporting/Report/TryParseAggregateColumnExpression";
            return $.ajax({
                type: "POST",
                dataType: "JSON",
                url: url,
                data: postedData
            });
        }

        var init = function (selector)
        {
            const selectorElement = $(selector);

            const aggregateCalculationBuilder = selectorElement.find("#aggregateCalculationBuilder");

            if (aggregateCalculationBuilder)
            {
                const reportSectionInput = aggregateCalculationBuilder.find("#aggregateCalculationReportSection");
                const reportFieldInput = aggregateCalculationBuilder.find("#aggregateCalculationReportField");
                const aggregateTypeInput = aggregateCalculationBuilder.find("#aggregateCalculationAggregateType");

                const insertFieldButton = aggregateCalculationBuilder.find("#aggregateCalculationInsert");

                const operationButtons = aggregateCalculationBuilder.find(".aggregateCalculationOperations .button");

                const expressionInput = aggregateCalculationBuilder.find("#aggregateCalculationExpression");

                reportSectionInput.on("change", function () { changeVisibleFields($(this).find(":selected").data("sectionId"), reportFieldInput); });

                reportFieldInput.on("change", function () { updateAggregateTypeInputBasedOnSelectedField(aggregateTypeInput, $(this).find(":selected").data()) });

                insertFieldButton.on("click", function ()
                {
                    let errors = {};
                    validateField(reportFieldInput, errors);
                    validateAggregateType(aggregateTypeInput, reportFieldInput, errors);
                    if (jQuery.isEmptyObject(errors))
                    {
                        skyward.validation.clearValidationMessages(aggregateCalculationBuilder, $())

                        insertFieldClick(expressionInput, reportFieldInput, aggregateTypeInput);

                        skyward.controls.setValue(reportFieldInput, "");
                        skyward.controls.setValue(aggregateTypeInput, "");
                    }
                    else
                    {
                        skyward.validation.displayValidationMessages({ errors: errors }, aggregateCalculationBuilder, $())
                    }
                });

                operationButtons.on("click", function () { operationClick(expressionInput, $(this)); });
            }
        }

        var changeVisibleFields = function (selectedSectionID, reportFieldInput)
        {
            skyward.controls.setValue(reportFieldInput, "");
            reportFieldInput.find("optgroup").each(function ()
            {
                const optionGroup = $(this);
                const sectionID = optionGroup.data('sectionId');

                skyward.controls.toggleVisible(optionGroup, sectionID === selectedSectionID, false);
            });
        }

        var updateAggregateTypeInputBasedOnSelectedField = function (aggregateTypeInput, selectedFieldData)
        {
            if (!selectedFieldData.isOnCurrentLine)
            {
                aggregateTypeInput.find("option").each(function ()
                {
                    const option = $(this);
                    //skip if its the blank option.
                    //We need the blank option to force people to choose change the value after changing the field so the selected value is correct.
                    if (option.val())
                    {
                        const availableForDataTypes = option.data("availableForDataTypes");
                        let showOption = availableForDataTypes.includes(selectedFieldData.dataType);
                        if (selectedFieldData.dataType && selectedFieldData.dataType.startsWith("String Enum"))
                        {
                            showOption = availableForDataTypes.some((dataType) => dataType.startsWith("String Enum"));
                        }

                        option.removeAttr("selected");
                        skyward.controls.toggleVisible(option, showOption, false);
                    }
                });
            }

            skyward.controls.setValue(aggregateTypeInput, "");
            skyward.controls.toggle(aggregateTypeInput, !selectedFieldData.isOnCurrentLine);
        }

        var validateField = function (reportFieldInput, errors)
        {
            if (!skyward.controls.getValue(reportFieldInput).trim())
            {
                errors["aggregateCalculationReportField"] = ["Report Field is required when inserting a field."]
            }
        };

        var validateAggregateType = function (aggregateTypeInput, reportFieldInput, errors)
        {
            if (reportFieldInput.find(":selected").data("isOnCurrentLine") === false && !skyward.controls.getValue(aggregateTypeInput).trim())
            {
                errors["aggregateCalculationAggregateType"] = ["Aggregate Type is required for columns not on the currently selected line when inserting a field."]
            }
        };

        var insertFieldClick = function(expressionInput, reportFieldInput, aggregateTypeInput)
        {
            const selectedField = reportFieldInput.find(":selected");
            const selectedAggregateType = aggregateTypeInput.find(":selected");
            const selectedAggregateTypeText = selectedAggregateType.val();

            const displayBinding = selectedField.data("displayBinding");

            if (selectedAggregateTypeText)
            {
                insertValue(expressionInput, selectedAggregateTypeText + "( " + displayBinding + " )");
            }
            else
            {
                insertValue(expressionInput, displayBinding);
            }
        };

        var operationClick = function (expressionInput, button)
        {
            var token = button.data("token");
            insertValue(expressionInput, token);
        };

        var insertValue = function (expressionInput, value)
        {
            skyward.global.text.insertTextToken(expressionInput, value, true);
        };

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);